import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'

import { JwtModule } from '@auth0/angular-jwt';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule
  , MAT_DATE_FORMATS, NativeDateAdapter, DateAdapter
  , MatInputModule, MatProgressSpinnerModule, MatMenuModule,
  MatIconModule, MatTableModule, MatSelectModule, MAT_DATE_LOCALE, MatFormFieldModule, MatCardModule,
  MatPaginatorModule,
} from '@angular/material';
import { NgbModule, NgbTooltipModule, NgbDatepickerModule, NgbPopoverModule, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatSliderModule } from '@angular/material/slider';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs'


import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MediaMatcher } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};

export class AppDateAdapter extends NativeDateAdapter {

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return date.toDateString();

    }
  }
}

import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AppComponent } from './app.component';
import { routing } from './app.routing';

import { HomeComponent } from './home/home.component';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './home/dashboard.component';
import { CompaniesCallbackComponent } from './home/companiescall.component';
import { DashboardCallbackComponent } from './home/dashboardcall.component';

// CUSTOMERS
import { CustomerDetailComponent } from './customers/customerdetail.component'
import { CustomerEditComponent } from './customers/customeredit.component'
import { CustomerImportComponent } from './customers/customerimport.component'
import { CompaniesListComponent } from './customers/companieslist.component'
import { PaymentCustomerImportComponent } from './customers/paymentcustomerimport.component';
import { newpaymentcustomerimport } from './customers/customer-list/customer-import-new/newpaymentcustomerimport.component';

// CUSTOMERS CREATE
import { OldCustomerCompanyCreateComponent } from './customers/create/company/old-version/old-customer-create.component'
import { NewCustomerCompanyCreateComponent } from './customers/create/company/new-version/new-customer-create.component';

// CUSTOMERS LIST
import { OldCustomerCorporateListComponent } from './customers/customer-list/coporate/old-version/old-customer-list.component';
import { NewCustomerCorporateListComponent } from './customers/customer-list/coporate/new-version/new-customer-list.component';
import { CustomerCorporateListController } from './customers/customer-list/coporate/controller/controller.component';

import { OldCustomerCompanyListComponent } from './customers/customer-list/company/old-version/old-customer-list.component';
import { NewCustomerCompanyListComponent } from './customers/customer-list/company/new-version/new-customer-list.component';
import { CustomerCompanyListController } from './customers/customer-list/company/controller/controller.component';

// INVOICE'S TABLE
import { HistoryTableComponent } from './invoices/components/history-table/history-table.component';
import { NotificationTableComponent } from './invoices/components/notification-table/notification-table.component';
// INVOICE CREATE
import { InvoiceCreateComponent } from './invoices/components/create/old-version/invoicecreate.component'
import { InvoiceImportComponent } from './invoices/invoiceimport.component'
import { NewInvoicesCreationComponent } from './invoices/components/create/new-version/new-invoices-creation.component';
import { AccordiondataComponent } from './invoices/accordiondata.component';
import { AccordioninvoicecreateComponent } from './invoices/components/create/old-version/extra-fields/accordioninvoicecreate.component';
// INVOICE CORPORATE
import { CorporateInvoiceViewComponent } from './invoices/corporate/view/view.component';
import { CorporateInvoiceEditComponent } from './invoices/corporate/edit/edit.component';
import { OldCorporateInvoiceListComponent } from './invoices/corporate/list/old-version/old-invoices-list.component';
import { NewCorporateInvoiceListComponent } from './invoices/corporate/list/new-version/new-invoices-list.component';
import { InvoicesCorporateListController } from './invoices/corporate/list/controller/controller.component';
// INVOICE COLLECT
import { CollectInvoiceListComponent } from './invoices/collect/list/list.component';
import { CollectInvoiceViewComponent } from './invoices/collect/view/view.component';
import { CollectInvoiceEditComponent } from './invoices/collect/edit/edit.component';
// INVOICE PAYMENT
import { PaymentInvoiceEditComponent } from './invoices/payment/edit/edit.component';
import { PaymentInvoiceViewComponent } from './invoices/payment/view/view.component';
import { NewInvoicesPaymentListComponent } from './invoices/payment/list/new-version/new-invoices-list.component';
import { OldInvoicesPaymentListComponent } from './invoices/payment/list/old-version/old-invoices-list.component';
import { InvoicesPaymentListController } from './invoices/payment/list/controller/controller.component';
// INVOICE PAYOUT
import { PayoutInvoiceListComponent } from './invoices/payout/list/list.component';
import { PayoutInvoiceViewComponent } from './invoices/payout/view/view.component';
// INVOICE IMPORT
import { PaymentInvoiceImportComponent } from './invoices/paymentinvoiceimport.component';

// PAYMENT
import { PaymentListComponent } from './payments/paymentlist.component'
import { PaymentDetailComponent } from './payments/paymentdetail.component'
import { PaymentCreateComponent } from './payments/paymentcreate.component'
import { PaymentEditComponent } from './payments/paymentedit.component'
import { ErrorsComponent } from './payments/errors.component'

// ACCOUNT
import { AccountsListComponent } from './accounts/accountslist.component'
import { AccountsOperationBankComponent } from './accounts/accountoperationbank.component'
import { AccountsOperationPspComponent } from './accounts/accountoperationpsp.component'
import { AccountsOperationVirtualComponent } from './accounts/accountoperationvirtual.component'
import { AccountCreateComponent } from './accounts/accountcreate.component'
import { AccountsOperationSettlementComponent } from './accounts/accountoperationsettlement.component'
import { AccountsOperationCollectComponent } from './accounts/accountoperationcollect.component'

import { AccountsOperationBankCategorizeComponent } from './accounts/accountoperationbankcategorize.component'

import { AccountsOperationPspDetailComponent } from './accounts/accountoperationpspdetail.component'

import { SettlementListComponent } from './accounts/settlementlist.component'
import { SettlementDetailComponent } from './accounts/settlementdetail.component'

import { PaymentListReportComponent } from './reports/paymentlistreport.component'

// SETTINGS
import { NewProfileComponent } from './settings/profile/new-version/new-profile.component';
import { OldProfileComponent } from './settings/profile/old-version/old-profile.component';
import { ProfileController } from './settings/profile/controller/controller.component';

import { TemplateListComponent } from './settings/templatelist.component';
import { TemplateCreateComponent } from './settings/templatecreate.component';
import { TemplateEditComponent } from './settings/templateedit.component';

import { NewUsersCreationComponent } from './settings/users/create/new-version/new-users-creation.component';
import { NewUserListComponent } from './settings/users/list/new-version/new-user-list.component';
import { OldUserListComponent } from './settings/users/list/old-version/old-user-list.component';

import { ConfigurationMenuComponent } from './settings/configurationmenu.component';
import { NotificationListComponent } from './settings/notificationlist.component';

import { ApiComponent } from './settings/api.component';
import { WebhookComponent } from './settings/webhook.component';
import { EventsComponent } from './settings/events/old-version/events.component';

import { NewApiKeyWebhookComponent } from './settings/apikey-webhook/new-version/new-apikey-webhook-version.component';
import { ApiKeySubComponent } from './settings/apikey-webhook/components/api-key/api-key.component';
import { WebhookSubComponent } from './settings/apikey-webhook/components/webhook/webhook.component';

import { NewPasswordComponent } from './settings/password/new-version/new-password.component';
import { LayoutComponent } from './settings/layout/layout.component';

// LOGIN
import { ForgotPwdComponent } from './login/forgot-password/forgotpassword.component';
import { ErrorComponent } from './home/error.component';
import { LogoutComponent } from './login/logout.component';
import { CallbackComponent } from './login/callback.component';

// PIPES
import { KcmsDatePipe } from './pipes/datetimezone.pipe';
import { OrderByPipe } from './pipes/sort.pipe';
import { dueDatePipe } from './pipes/duedate.pipe';
import { kcmsDateTwelvePipe } from './pipes/kcmsdate.pipe';
import { newKcmsDateTwelvePipe } from './pipes/new-kcmsdate.pipe';
import { kcmsIncludeSecondsDateTwelvePipe } from './pipes/kcms-include-seconds-date.pipe';
import { InitialnamePipe } from './pipes/initialname.pipe';

//SHARED
import { ArraySortPipe } from './sharedcomp/arrsortpipe.pipe';
import { ChartistComponent } from './sharedcomp/chartist.component';
import { ChartistInvoiceComponent } from './sharedcomp/chartistinv.component';
import { ConfirmationDialogComponent } from './sharedcomp/confirmdialog.component';
import { ResizableDirective, GrabberDirective } from './sharedcomp/resizable';
import { VersionComponent } from './sharedcomp/version/version.component';
import { SidebarComponent } from './sharedcomp/sidebar/sidebar.component';
import { DropdownComponent } from './sharedcomp/ui-components/drpdowns/dropdown/dropdown.component';
import { FooterComponent } from './sharedcomp/footer.component';
import { HeaderComponent } from './sharedcomp/header.component';
import { OldSnavMenuComponent } from './sharedcomp/snavmenu/old-version/old-snav-menu.component';
import { NewSnavMenuComponent } from './sharedcomp/snavmenu/new-version/new-snav-menu.component';
import { SnavMenuController } from './sharedcomp/snavmenu/controller/controller.component';

import { NgxEditorModule } from 'ngx-editor';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AngularEditorModule } from '@kolkov/angular-editor';

import { SalesInvoiceCreateComponent } from './sales/salesinvoicecreate.component';

import { SalesInvoicesListComponent } from './sales/salesinvoicelist.component';

import { SalesInvoiceDetailComponent } from './sales/salesinvoicedetail.component';

import { SalesInvoiceEditComponent } from './sales/salesinvoiceedit.component';
import { AccountOperationbankImport } from './accounts/accountoperationbankimport.component';
import { SettlementCorporateListComponent } from './reports/settlementcorporatelist.component';
import { PaymentCorporateListReportComponent } from './reports/paymentcorporatelist.component';
import { BatchesListComponent } from './processes/batch-list/old-version/batches.component';
import { BatchListController } from './processes/batch-list/controller/controller.component';
import { NewProcessImportComponent } from './processes/process-import/new-process-import/new-process-import.component';
import { ProcessOperationbankImport } from './processes/process-import/old-process-import/processimport.component';
import { PayoutProcessViewComponent } from './payout_process/payoutprocessview.component';

import {
  CustomerService
  , AuthenticationService
  , DebtorService
  , InvoicesService
  , PaymentProcessService
  , NotificationService
  , AccountService
  , AuthService
  , AuthGuardService
  , SettlementProcessService
  , UserService
  , DashboardService
  , ConfigurationService
  , ConfirmationDialogService
  , ProcessService
  , EventsService
  , TemplateService
  , PayoutService
  , DebtorDataService
  , CommonDataService
  , BackFilterService
  , ExcelDateConvertService
  , NewImportProcessService
  , PreloadService
} from './_services/index';

import {
  AppConfig, ExcelService, JwtInterceptor,
  ParameterData, DataService
  , ErrorsHandlerService, NotificationService_UnUsed, AccessConfig
  , SanitizeHtmlPipe, RouteTransformerDirective, CustomValidators
  , PreviousRouteService, DragDropFileDirective
} from './_helpers/index';

import {
  debtordocumenttype, debtorTipo,
  debtorPhonePrefix, debtorStatus,
  Status, Overduedate, ExpirationRank,
  Creation, currencysymbolPrefix,
  PaymentCreation, PaymentStatus
  , accountStatus, accountType
  , bankName, accountPSPCreation
  , accountPSPStatus, accountPSPType
  , accountVirtualType, accountBankStatus
  , accountSettlementCreation, accountSettlementStatus
  , accountBankType
  , graphYear, graphDataBy
  , notificationStatus, notificationType, accountBankCategoryStatus, CreationBatch, StatusBatch, TypeBatch, SettlementReportFilter,
  PayoutCreation, PayoutCommerceCreation, PayoutCommerceStatus, PayoutStatus, AccountPayoutStatus, AccountPayoutCreation, AccountPayoutType, PaymentType,NotificationReportCreation, NotificationReportStatus, NotificationReportChannel
  , InvoicePaymentTypes,
  DocumentService
} from './_enums/index';
import { NotificationReportListComponent } from './reports/notificationreportlist.component';
import { PayoutProcessListComponent } from './payout_process/payoutprocesslist.component'
import { AccountOperationPayoutComponent } from './accounts/accountoperationpayout.component'

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DisableRightClickDirective } from './_helpers/directives/disable-right-click.directive';
import { NewPayoutprocessImportComponent } from './payout_process/payout-import-process/new-payout-import-version/new-payoutprocess-import.component';
import { PayoutprocessCommerceComponent } from './payout_process/payoutprocesscommerce/payoutprocesscommerce.component';
import { PayoutprocesscommerceviewComponent } from './payout_process/payoutprocesscommerceview/payoutprocesscommerceview.component';
import { PayoutprocesscommerceconfirmComponent } from './payout_process/payoutprocesscommerceconfirm/payoutprocesscommerceconfirm.component';
import { TemplatesTableComponent } from './sharedcomp/templates-table/templates-table.component';
import { SharedImportProcessComponent } from './sharedcomp/shared-import-process/shared-import-process.component';

import { OldPayoutInvoiceImportVersionComponent } from './invoices/payout-invoice-import-process/old-payout-invoice-import-version/old-payout-invoice-import-versioncomponent';

import { OldPayoutImportVersionComponent } from './payout_process/payout-import-process/old-payout-import-version/old-payout-import-version.component';

import { VersionService } from './_services/version.service';
import { CustomPaginatorStyleDirective } from './_helpers/directives/custom-paginator-style.directive';
import { CustomSelectStyleDirective } from './_helpers/directives/custom-select-style.directive';
import { CustomDropdownTableDirective } from './_helpers/directives/custom-dropdown-table.directive';
import { CustomMatCheckboxDirective } from './_helpers/directives/custom-mat-checkbox.directive';
import { FormatterDatepickerPipe } from './_helpers/formatter-datepicker.pipe';
import { CustomDateRangePickerDirective } from './_helpers/directives/custom-date-range-picker.directive';
import { I18n } from './_services/i18n.service';
import { CustomDatepickerI18n } from './_helpers/custom-datepicker-I18n';
import { CustomV2DesignLayoutDirective } from './_helpers/directives/custom-v2-design-layout.directive';
import { NewHeaderComponent } from './sharedcomp/new-header/new-header.component';
import { CustomSelectComponent } from './sharedcomp/selects/custom-select/custom-select.component';
import { AmortizationsTableComponent } from './invoices/components/amortizations-table/amortizations-table/amortizations-table.component';
import { InvoicePaymentTypePipe } from './pipes/invoice-payment-type.pipe';
import { CustomTabsDirective } from './_helpers/directives/custom-tabs.directive';
import { FocusDirective } from './_helpers/directives/focus.directive';
import { CustomIconSelectComponent } from './sharedcomp/selects/custom-icon-select/custom-icon-select.component';
import { CustomSelectV2Component } from './sharedcomp/selects/custom-select-v2/custom-select-v2.component';
import { CustomCountryPhoneSelectComponent } from './sharedcomp/selects/custom-country-phone-select/custom-country-phone-select.component';
import { CustomCountryPhoneSelectV2Component } from './sharedcomp/selects/custom-country-phone-select-v2/custom-country-phone-select-v2.component';
import { CustomClipboardCopyInputComponent } from './sharedcomp/ui-components/inputs/custom-clipboard-copy-input/custom-clipboard-copy-input.component';
import { AccountTypeLabelPayoutProcessPipe } from './pipes/account-type-label-payout-process.pipe';
import { NewProcessImportComponentComponent } from './processes/process-import/new-process-import/new-process-import-component/new-process-import-component.component';
import { PayoutProcessCommerceMasiveConfirmComponent } from './payout_process/payout-process-commerce-masive-confirm/payout-process-commerce-masive-confirm.component';
import { NewNotificactionsVersionComponent } from './settings/notifications/new-version/new-notificactions-version.component';
import { TemplateComponent } from './settings/notifications/pages/templates/templates.component';
import { NotificationScheduleComponent } from './settings/notifications/pages/notification-schedule/notification-schedule.component';
import { NgbdModalContent } from './sharedcomp/ui-components/modals/modal-v1/modal-v1.component';
import { CreateTemplateFormComponent } from './settings/notifications/pages/create-template-form/create-template-form.component';
import { EditDuplicateTemplateFormComponent } from './settings/notifications/pages/edit-duplicate-template-form/edit-duplicate-template-form.component';
import { CustomAngularEditorDirective } from './_helpers/directives/custom-angular-editor.directive';
import { CreateNotificationFormComponent } from './settings/notifications/pages/notification-schedule/pages/create-notification-form/create-notification-form.component';
import { EditNotificationFormComponent } from './settings/notifications/pages/notification-schedule/pages/edit-notification-form/edit-notification-form.component';
import { EventsNewVersionComponent } from './settings/events/new-version/events-new-version.component';
import { ModalEditEventComponent } from './settings/events/new-version/Modal/modal-edit-event.component';
import { CustomSelectV3Component } from './sharedcomp/selects/custom-select-v3/custom-select-v3.component';
import { EventsNewVersionService } from './settings/events/new-version/events-new-version.service';
import { NewBatchesVersionComponent } from './settings/batches/new-version/new-batches-version.component';
import { DropdownIconOptionComponent } from './sharedcomp/ui-components/drpdowns/dropdown-icon-option/dropdown-icon-option.component';
import { NewProcessImportCustomerComponent } from './customers/customer-list/customer-import-new/new-process-import-customer.component';
import { PaymentCustomerImportComponentv1 } from './customers/paymentcustomerimportv1.component';
import { CustomSelectV4Component } from './sharedcomp/selects/custom-select-v4/custom-select-v4.component';
import { SpinnerLoaderComponent } from './sharedcomp/ui-components/spinner-loader/spinner-loader.component';
import { NoDataFoundComponent } from './sharedcomp/ui-components/response-messages/no-data-found/no-data-found.component';
import { ErrorMessageComponent } from './sharedcomp/ui-components/response-messages/error/error.component';

import { BillingComponent } from './settings/billing/new-version/billing.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  bootstrap: [AppComponent],
  providers: [
    AppConfig,
    AccessConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },

    { provide: MAT_DATE_LOCALE, useValue: 'es' },

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {
        displayDefaultIndicatorType: false,
        showError: false
      }
    },
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
    CustomerService,
    ExcelService,
    AuthenticationService,
    ParameterData,
    DebtorService,
    DataService,
    ConfigurationService,
    debtordocumenttype,
    debtorTipo,
    debtorStatus,
    debtorPhonePrefix,
    DocumentService,
    currencysymbolPrefix,
    Status,
    Overduedate,
    ExpirationRank,
    Creation,
    PaymentCreation,
    PaymentStatus,
    PayoutCreation,
    PayoutCommerceCreation,
    PayoutCommerceStatus,
    PayoutStatus,
    AccountPayoutCreation,
    AccountPayoutStatus,
    AccountPayoutType,
    accountStatus,
    accountType,
    CreationBatch,
    StatusBatch,
    TypeBatch,
    bankName,
    graphYear,
    InvoicePaymentTypes,
    graphDataBy,
    InvoicesService,
    PaymentProcessService,
    AccountService,
    AuthService,
    AuthGuardService,
    ProcessService,
    NotificationService_UnUsed,
    NotificationService,
    ErrorsHandlerService,
    accountPSPCreation,
    accountPSPStatus, accountPSPType, accountVirtualType,
    accountBankStatus, accountBankType
    , accountSettlementCreation, accountSettlementStatus
    , accountBankCategoryStatus
    , SettlementProcessService
    , SanitizeHtmlPipe
    , { provide: ErrorHandler, useClass: ErrorsHandlerService }
    , UserService
    , DashboardService
    , { provide: ErrorHandler, useClass: ErrorsHandlerService }
    , Title
    , notificationStatus, notificationType
    , CustomValidators
    , { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    , PreviousRouteService
    , ConfirmationDialogService
    , EventsService
    , SettlementReportFilter
    , TemplateService
    , PayoutService
    , PaymentType
    , DebtorDataService
    , CommonDataService
    , NotificationReportCreation
    , NotificationReportStatus
    , NotificationReportChannel
    , BackFilterService
    , ExcelDateConvertService
    , NewImportProcessService
    , VersionService
    , PreloadService
    , MediaMatcher,
    EventsNewVersionService
    , I18n
    , { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
  declarations: [
    AppComponent
    , HomeComponent
    , HeaderComponent
    , FooterComponent
    , LoginComponent
    , OldSnavMenuComponent
    , NewSnavMenuComponent
    , SnavMenuController
    , DashboardComponent
    , OldCustomerCompanyListComponent
    , OldCustomerCompanyCreateComponent
    , CustomerEditComponent
    , CustomerDetailComponent
    , CustomerImportComponent
    , OldCustomerCorporateListComponent
    , NewCustomerCorporateListComponent
    , CustomerCorporateListController
    , CompaniesListComponent
    , CompaniesCallbackComponent
    , DashboardCallbackComponent
    , InvoiceCreateComponent
    , InvoiceImportComponent
    , OldCorporateInvoiceListComponent
    , NewCorporateInvoiceListComponent
    , InvoicesCorporateListController
    , CorporateInvoiceViewComponent
    , CorporateInvoiceEditComponent

    , PaymentListComponent
    , PaymentDetailComponent
    , PaymentCreateComponent
    , PaymentEditComponent
    , ErrorsComponent
    , AccountsListComponent
    , AccountsOperationBankComponent
    , AccountsOperationPspComponent
    , AccountsOperationVirtualComponent
    , AccountCreateComponent
    , AccountsOperationSettlementComponent
    , AccountsOperationCollectComponent
    , AccountsOperationBankCategorizeComponent
    , AccountsOperationPspDetailComponent
    , SettlementListComponent
    , SettlementDetailComponent
    , AccountOperationbankImport
    , PaymentListReportComponent
    , SettlementCorporateListComponent
    , ConfirmationDialogComponent
    , ArraySortPipe
    , KcmsDatePipe
    , OrderByPipe
    , dueDatePipe
    , kcmsDateTwelvePipe
    , kcmsIncludeSecondsDateTwelvePipe
    , newKcmsDateTwelvePipe
    , ChartistComponent
    , ChartistInvoiceComponent
    , ForgotPwdComponent
    , NewProfileComponent
    , OldProfileComponent
    , ProfileController
    , TemplateListComponent
    , TemplateCreateComponent
    , TemplateEditComponent
    , ConfigurationMenuComponent
    , NotificationListComponent
    , BatchesListComponent
    , BatchListController
    , ProcessOperationbankImport
    , NewProcessImportCustomerComponent
    , ErrorComponent
    , LogoutComponent
    , CallbackComponent
    , SanitizeHtmlPipe
    , RouteTransformerDirective
    , PaymentCorporateListReportComponent
    , SalesInvoiceCreateComponent
    , SalesInvoicesListComponent
    , SalesInvoiceDetailComponent
    , SalesInvoiceEditComponent
    , ApiComponent
    , WebhookComponent
    , OldUserListComponent
    , ResizableDirective
    , GrabberDirective
    , EventsComponent
    , ApiKeySubComponent
    , WebhookSubComponent
    , NotificationReportListComponent
    , PayoutProcessListComponent
    , AccountOperationPayoutComponent
    , PayoutProcessViewComponent
    , PaymentInvoiceImportComponent
    , newpaymentcustomerimport
    , PaymentCustomerImportComponent
    , PaymentCustomerImportComponentv1
    , DisableRightClickDirective
    , AccordiondataComponent
    , AccordioninvoicecreateComponent
    , NewPayoutprocessImportComponent
    , PayoutprocessCommerceComponent
    , PayoutprocesscommerceviewComponent
    , PayoutprocesscommerceconfirmComponent
    , TemplatesTableComponent
    , DragDropFileDirective
    , SharedImportProcessComponent
    , OldPayoutInvoiceImportVersionComponent
    , OldPayoutImportVersionComponent
    , VersionComponent
    , PaymentInvoiceEditComponent
    , PaymentInvoiceViewComponent
    , NewInvoicesPaymentListComponent
    , OldInvoicesPaymentListComponent
    , InvoicesPaymentListController
    , PayoutInvoiceListComponent
    , PayoutInvoiceViewComponent
    , HistoryTableComponent
    , NotificationTableComponent
    , CollectInvoiceListComponent
    , CollectInvoiceViewComponent
    , CollectInvoiceEditComponent
    , NewCustomerCompanyListComponent
    , InitialnamePipe
    , CustomPaginatorStyleDirective
    , CustomSelectStyleDirective
    , CustomDropdownTableDirective
    , CustomerCompanyListController
    , NewCustomerCompanyCreateComponent
    , SidebarComponent
    , DropdownComponent
    , CustomMatCheckboxDirective
    , NewInvoicesCreationComponent
    , FormatterDatepickerPipe
    , CustomDateRangePickerDirective
    , CustomV2DesignLayoutDirective
    , NewHeaderComponent,
    CustomSelectComponent,
    AmortizationsTableComponent,
    InvoicePaymentTypePipe,
    LayoutComponent,
    CustomTabsDirective,
    FocusDirective,
    NewPasswordComponent,
    CustomIconSelectComponent,
    NewUserListComponent,
    NewUsersCreationComponent,
    CustomSelectV2Component,
    CustomSelectV4Component,
    CustomCountryPhoneSelectComponent,
    CustomCountryPhoneSelectV2Component,
    NewApiKeyWebhookComponent,
    CustomClipboardCopyInputComponent,
    AccountTypeLabelPayoutProcessPipe,
    NewProcessImportComponent,
    NewProcessImportComponentComponent,
    PayoutProcessCommerceMasiveConfirmComponent,
    NewNotificactionsVersionComponent,
    TemplateComponent,
    NotificationScheduleComponent,
    NgbdModalContent,
    CreateTemplateFormComponent,
    EditDuplicateTemplateFormComponent,
    CustomAngularEditorDirective,
    CreateNotificationFormComponent,
    EditNotificationFormComponent,
    EventsNewVersionComponent,
    ModalEditEventComponent,
    CustomSelectV3Component,
    NewBatchesVersionComponent,
    DropdownIconOptionComponent,
    SpinnerLoaderComponent,
    NoDataFoundComponent,
    ErrorMessageComponent
    , BillingComponent
  ],

  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSortModule,
    MatSliderModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    JwtModule,
    routing,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatDividerModule,
    MatToolbarModule,
    MatSidenavModule,
    FroalaEditorModule.forRoot(), FroalaViewModule.forRoot()
    , Ng4LoadingSpinnerModule.forRoot()
    , NgxEditorModule
    , AngularEditorModule
    , TooltipModule.forRoot()
    , AlertModule.forRoot()
    , ModalModule.forRoot()
    , NgbModule.forRoot()
    , NgbTooltipModule
    , NgbDatepickerModule
    , NgbPopoverModule
    , OverlayModule,
    MatCardModule
  ],

  entryComponents: [ConfirmationDialogComponent, NewInvoicesPaymentListComponent, NgbdModalContent, ModalEditEventComponent]

})
export class AppModule { }
